import "antd/lib/message/style";
import _message from "antd/lib/message";
function BossMessage(success, content, duration) {
  if (success) {
    _message.success(content, duration);
  } else {
    _message.error(content, duration);
  }
}
export { BossMessage };